var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"position-relative z-index-2",attrs:{"id":"section-cards"}},[_c('ul',_vm._l((_vm.images.slice(0, 18)),function(image,index){return _c('li',{key:index,ref:"images",refInFor:true,style:({ backgroundImage: `url(${image})` })})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }